import _ from 'lodash';

import { SelectOptionsProps } from '@/shared/types/shared-types/select.type';

const convertEnumsToIDLabelArr = (data: { [key: string]: string }) => {
  const convertedData = Object.keys({ ...data }).map((key) => ({
    id: key.toLowerCase(),
    label: _.startCase(data[key])
  }));
  return convertedData;
};

/**
 * convert enum to id label array with start case
 * @param data enum object {NEEDS_FOLLOW_UP: 'Needs follow up', FIND_DUPLICATES: 'Find duplicates' } 
 * @returns [{ id: 'needsFollowUp', label: 'Needs follow up' }, { id: 'findDuplicates', label: 'Find duplicates' }]
 */

const convertEnumsToIDLabelArrWithCamelCase = (data: { [key: string]: string }) => {
  const convertedData = Object.keys({ ...data }).map((key) => ({
    id: _.camelCase(key),
    label: _.startCase(data[key])
  }));
  return convertedData;
};

const getIDLabelValue = (data: SelectOptionsProps[], id: string | undefined) => {
  if (id) {
    return data.find((obj) => obj.id === id);
  } else return { id: '', label: '' };
};

export { convertEnumsToIDLabelArr, convertEnumsToIDLabelArrWithCamelCase, getIDLabelValue };
